module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/5-0d3ec7a17fa5428494d2d096bcd3d1fc.png";